(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.ZonesHandler = (function(superClass) {
    extend(ZonesHandler, superClass);

    function ZonesHandler() {
      return ZonesHandler.__super__.constructor.apply(this, arguments);
    }

    ZonesHandler.prototype.init = function() {
      this.layoutUrl = 'backend/portal/zones/load-layout';
      this.layoutSelector = App.sidebar.contentDiv();
      this.subHandlers = {
        'Zones': {
          'class': 'portal::handlers/zones/ZonesDialogHandler'
        }
      };
      this.defaultSub = 'Zones';
      return this.loadLayout();
    };

    ZonesHandler.prototype.afterLoadLayout = function(selector, response) {
      var handler, layout, ref, self;
      if (((ref = response.status) != null ? ref.type : void 0) !== 'success') {
        return;
      }
      self = this;
      layout = $(this.layoutSelector);
      handler = this.createSubHandler(this.defaultSub);
      if (handler) {
        handler.init();
      } else {
        throw new Error(this.defaultSub + " is not a valid subhandler");
      }
      layout.find('.sel-pp').on('change', function() {
        layout.find('.sel-pp').not(this).val($(this).val());
        return self.refreshSubHandlers();
      });
      layout.find('.nav-tabs [href="#zones"]').on('click', function() {
        return layout.find('#sel_sz_pp').trigger('change');
      });
      return layout.find('#btn_add_zone').on('click', (function(_this) {
        return function() {
          var k, ref1, results, v;
          ref1 = _this.activeSubHandlers;
          results = [];
          for (k in ref1) {
            v = ref1[k];
            results.push(typeof v.addEditZone === "function" ? v.addEditZone() : void 0);
          }
          return results;
        };
      })(this));
    };

    return ZonesHandler;

  })(Handler);

}).call(this);
